import IJsonResponse from "@/utils/types/IJsonResponse";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import StoreService from "@/store";
import HttpClient from "@/services/HttpClient";
import { ICustomer } from "@/modules/banks/types";

@injectable()
export default class KycClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async fetchKycRecord(id: number): Promise<IJsonResponse> {
    const response = await this.http.get(`/v1/app/admin/kyc/${id}`);
    this.store.commit("KycModule/setKyc", response.data);
    return response;
  }
}
